module.exports = __webpack_public_path__ + "static/media/react.7be113a5.svg";